import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-between" }
const _hoisted_2 = { class: "my-2 gap-8 display: flex" }
const _hoisted_3 = { class: "text-[#27AE60]" }
const _hoisted_4 = { class: "text-[#3498DB]" }
const _hoisted_5 = { class: "text-base text-green mt-2" }
const _hoisted_6 = { class: "w-full bg-gray-200 rounded-full h-2.5" }

import {formatAmount} from "@/helpers/utilities/dataFormats";
import {ref} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CampaignProgressBar',
  props: {
  cumulativeDonations: {
    type: Number,
    required: true,
  },
  targetAmount: {
    type: Number,
    required: true,
  }
},
  setup(__props) {


const props = __props

const cumulativeDonations = ref(props.cumulativeDonations)
const targetAmount = ref(props.targetAmount)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("ul", _hoisted_2, [
        _createElementVNode("li", _hoisted_3, " • R " + _toDisplayString(_unref(formatAmount)(cumulativeDonations.value ?? 0)) + " funded ", 1),
        _createElementVNode("li", _hoisted_4, " • R " + _toDisplayString(_unref(formatAmount)(targetAmount.value - (cumulativeDonations.value ?? 0))) + " funding left ", 1)
      ]),
      _createElementVNode("p", _hoisted_5, _toDisplayString(Math.round(((cumulativeDonations.value ?? 0) / targetAmount.value ?? 1 ) * 100)) + "%", 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", {
        class: "bg-green h-2.5 rounded-full",
        style: _normalizeStyle({ width: ((cumulativeDonations.value ?? 0) / targetAmount.value ?? 1) * 100 + '%' })
      }, null, 4)
    ])
  ], 64))
}
}

})